import { render, staticRenderFns } from "./AppGrain.vue?vue&type=template&id=5a7823c6&scoped=true&"
import script from "./AppGrain.vue?vue&type=script&lang=js&"
export * from "./AppGrain.vue?vue&type=script&lang=js&"
import style0 from "./AppGrain.vue?vue&type=style&index=0&id=5a7823c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7823c6",
  null
  
)

export default component.exports